import { Box, useTheme } from '@mui/material';
import { useCreateGuardianWithPatient } from '_api';
import { Guardian, GuardianPayload } from '_api/types';
import { AdminRouteMap, PatientRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { DefaultNewGuardianWithPatient } from '_constants/object-templates';
import { FormHeaderText, TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { AddPatientForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useNavigateTo } from 'utils';

export const AddPatient = () => {
  const navigate = useNavigateTo();
  const theme = useTheme();
  const { mutateAsync: create } = useCreateGuardianWithPatient();
  const [newPatientGuardian, setNewPatientGuardian] = useState(
    DefaultNewGuardianWithPatient,
  );
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onBack = () => navigate(AdminRouteMap.PATIENTS);

  const onUpdate = async (key: any, arg: any) => {
    setNewPatientGuardian((current) => ({
      ...current,
      [key]: arg,
    }));
  };

  const onSubmit = (value: GuardianPayload) => {
    create({
      ...value,
    })
      .then((data) => {
        setShowSuccess(true);
        const { patients } = data as Guardian;
        const lastIndex = patients.length - 1;
        setTimeout(() => {
          navigate(PatientRouteMap.DETAIL, patients[lastIndex].id.toString());
        }, 2500);
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please refresh the page and try again.',
          );
        } else if (error.message) {
          setErrorMessage(`ERROR: ${error.message}`);
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    <Box>
      <Box>
        <FormHeaderText gutterBottom>Child Detail</FormHeaderText>
        <TextButton
          onClick={onBack}
          sx={{ color: theme.palette.primary.main, marginBottom: '10px', paddingLeft: 0 }}
        >
          <IoArrowBackOutline />
          BACK
        </TextButton>
      </Box>
      <Box>
        <AddPatientForm
          initValue={newPatientGuardian}
          disableAll={showSuccess}
          onSubmit={onSubmit}
          onUpdate={onUpdate}
          onBack={onBack}
        />
      </Box>
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Patient successfully created and welcome email sent.'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </Box>
  );
};
